module.exports = __webpack_public_path__ + "static/media/brien.bcd255ad.png";